//Imports

import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import "./components.css"
import {useNavigate} from "react-router-dom";
import genavatar from "../pages/content/startpage_image.png"
import MailIcon from '@mui/icons-material/Mail';
import NotificationsIcon from '@mui/icons-material/Notifications';
import {Badge} from "@mui/material";

//Function Appbar

const ResponsiveAppBar = () => {

    //Declarations inside Appbar Function

    let navigate = useNavigate()

    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [anchorElUser, setAnchorElUser] = React.useState(null);

    //Functions Custom
    const directstart = () => {
        navigate("/")
    }

    const logout = () => {
        navigate("/intern/login")
    }

    const directsupport = () => {
        navigate("/intern/settings/hilfe")

    }

    const directsettings = () => {
        navigate("/intern/settings")
    }

    const directinternstart = () => {
        navigate("/internstart")
    }

    //Functions Standard

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    //Badge Function

   const notify = () => {
       navigate("")
   }






    //Start Rendered Function
    return (
        <AppBar position="static" sx={{backgroundColor: "black"}}>
            <Container maxWidth="xl">
                <Toolbar disableGutters>
                    <Typography
                        variant="h6"
                        noWrap
                        component="div"
                        sx={{ mr: 2, display: { xs: 'none', md: 'flex' } }}
                    >
                        
                    </Typography>

                    <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                        <IconButton
                            size="large"
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleOpenNavMenu}
                            color="inherit"
                        >
                            <MenuIcon />
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorElNav}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            open={Boolean(anchorElNav)}
                            onClose={handleCloseNavMenu}
                            sx={{
                                display: { xs: 'block', md: 'none' },
                            }}
                        >

                        </Menu>
                    </Box>
                    <Typography
                        variant="h6"
                        noWrap
                        component="div"
                        sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}
                    >
                        
                    </Typography>

                    {
                        //LEFT SIDE MENU STARTS HERE -->
                    }
                    <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                       {/* <Button variant="contained"
                                sx={{backgroundColor: "transparent", "&:hover":{ backgroundColor: "#ba10d1"}}}
                        onClick={directstart}>
                            Start
                </Button> */}
                        <Button variant={"contained"} sx={{backgroundColor: "transparent", "&:hover":{ backgroundColor: "#ba10d1"}}} onClick={directinternstart}>Home</Button>
                        {/*<Button variant={"contained"} sx={{backgroundColor: "transparent", "&:hover":{ backgroundColor: "#ba10d1"}}} onClick={directsupport}>
                            Hilfe
            </Button> */}
            <a  href='https://timtube-streaming.web.app/'> 
                         <Button variant={"contained"} sx={{backgroundColor: "transparent", "&:hover":{ backgroundColor: "#ba10d1"}}}>Timtube</Button>
                </a>        



                    </Box>

                    <Box sx={{ flexGrow: 0 }}>
                        <IconButton size="large" aria-label="show 4 new mails" color="inherit" >
                            <Badge badgeContent={0} color="error" variant={"dot"} showZero={false} >
                                <MailIcon />
                            </Badge>
                        </IconButton>
                        <IconButton
                            size="large"
                            aria-label="show 17 new notifications"
                            color="inherit"
                        >
                            <Badge badgeContent={0} color="error" onClick={notify} variant={"dot"} showZero={false} sx={{m:2}}>
                                <NotificationsIcon />
                            </Badge>
                        </IconButton>
                        {
                            //TODO Add Functions to Notification Bell
                        }
                        <Tooltip title="Easteregg: YEET">
                            <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                                <Avatar alt="User" src={genavatar} />
                            </IconButton>
                        </Tooltip>


                        <Menu
                            sx={{ mt: '45px' }}
                            id="menu-appbar"
                            anchorEl={anchorElUser}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={Boolean(anchorElUser)}
                            onClose={handleCloseUserMenu}
                        >
                            {
                                //RIGHT ICON MENU STARTS HERE -->
                            }
                            <MenuItem onClick={directsettings}>Einstellungen</MenuItem>
                            <MenuItem onClick={directsupport}>Hilfe</MenuItem>
                            <MenuItem onClick={logout}>Logout</MenuItem>
                        </Menu>
                    </Box>
                </Toolbar>
            </Container>
        </AppBar>
    );
};
export default ResponsiveAppBar;
